/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren} from "@angular/core";
import {ScoreComponent} from "./score/score.component";
import {FloatingComponent} from "../floating/floating.component";

/**
 * todo
 */
@Component({
	selector: "aigia-score-table",
	templateUrl: "./score-table.component.html",
	styleUrls: ["../floating/floating.component.css", "./score-table.component.css"],
})
export class ScoreTableComponent extends FloatingComponent implements OnInit {

	@Input() public locked: boolean;
	@Input() public shots: any[];
	@Input() public type: string;
	@Input() public subtype: string;
	@Input() public size: number[];

	@Input() public endpoint: string;

	@Output() public progrssChange = new EventEmitter<boolean>();

	@ViewChildren(ScoreComponent) public ScoreComponents: QueryList<ScoreComponent>;

	public title: string = "";

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		switch (this.type) {
			case "ballistic":
				this.title = "Ballistic Score";
				break;
			case "posture":
				this.title = "Posture Score";
				break;
			default:
				break;
		}
	}

}
